import { useEffect, useState } from "react";
import SectionTitle from "./SectionTitle";
import EmptyResult from "./empty-result/emptyResult";
import _ from "lodash";

const Announcements = () => {

    const [response, setResponse] = useState([] as any)
    const BASE_URL = 'https://slida-cms.dlad.io/api/';

    const commonParams = {
        populate: [
            '*'
        ]
    }

    async function fetchData() {
        const [pageRes] = await Promise.all([
            fetch(`${BASE_URL}website-announcements`, { cache: 'no-store' }),
        ]);

        return await Promise.all([pageRes.json()]);
    }

    useEffect(() => {
        fetchData().then((result) => setResponse(result)).catch((error) => console.log(error))
    }, [])

    // const heroData: any = _.get(response, ['data', 'attributes'], {})
    const announcements: any = response && response[0] && response[0]?.data

    return (
        <>
            <SectionTitle title="Announcements" />
            {_.isArray(announcements) ?
                (
                    <div className="flex flex-col space-y-4">
                        {announcements?.map((line: any) => (
                            <AnnouncementLine date={line.attributes.Date} title={line.attributes.Title} description={line.attributes.Announcement} />
                        ))}
                    </div>
                )
                :
                (
                    <div className="w-full flex justify-center items-center mb-12">
                        <EmptyResult showSymbol={false} title={"No any announcements found"} />
                    </div>
                )
            }

        </>
    );
};


const AnnouncementLine = ({ title, description, date }: any) => {

    return (
        <div className="p-4 bg-white rounded-lg flex flex-col space-y-2">
            <p>{date}</p>
            <h4 className="text-xl font-bold text-black sm:text-xl lg:text-xl lg:leading-tight xl:text-xl xl:leading-tight">
                {title}
            </h4>

            <p>{description}</p>
        </div>
    )
}

export default Announcements;